import { DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';

import { Button } from '@/components/Button';
import { CreateSprintRequest } from '@/tracker/types';
import { PresenceDialog } from '@/tracker/ui/PresenceDialog';

type Props = {
  /** Правка — текущие значения спринта; создание — предложенные даты */
  initial: CreateSprintRequest;
  isEdit: boolean;
  isSaving: boolean;
  /** true — сохранено, диалог можно закрыть */
  onSubmit: (data: CreateSprintRequest) => Promise<boolean>;
  onClose: () => void;
};

/** Создание и правка спринта: название и даты */
const SprintDialog: React.FC<Props> = ({ initial, isEdit, isSaving, onSubmit, onClose }) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<CreateSprintRequest>({ defaultValues: initial });

  const submit = handleSubmit(async ({ name, startDate, endDate }) => {
    if (await onSubmit({ name: name.trim(), startDate, endDate })) onClose();
  });

  return (
    <PresenceDialog onClose={onClose} maxWidth="xs" fullWidth>
      <form onSubmit={submit}>
        <DialogTitle>{isEdit ? 'Спринт' : 'Новый спринт'}</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}
        >
          <TextField
            label="Название"
            size="small"
            autoFocus
            error={!!errors.name}
            helperText={errors.name?.message}
            {...register('name', { validate: (value) => !!value.trim() || 'Введите название' })}
          />
          <TextField
            type="date"
            label="Начало"
            size="small"
            slotProps={{ inputLabel: { shrink: true } }}
            {...register('startDate', { required: true })}
          />
          <TextField
            type="date"
            label="Окончание"
            size="small"
            error={!!errors.endDate}
            helperText={errors.endDate?.message}
            slotProps={{ inputLabel: { shrink: true } }}
            {...register('endDate', {
              required: true,
              validate: (value) => value >= getValues('startDate') || 'Окончание раньше начала',
            })}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="text" onClick={onClose}>
            Отмена
          </Button>
          <Button type="submit" disabled={isSaving}>
            {isEdit ? 'Сохранить' : 'Создать'}
          </Button>
        </DialogActions>
      </form>
    </PresenceDialog>
  );
};

export { SprintDialog };
